import React, { type MouseEventHandler, useCallback } from 'react';

import { AddOutlined } from '@mui/icons-material';
import { ButtonBase } from '@mui/material';
import { useSetCurrentBlockId } from '@wp-block-builder/editor/hooks';
import { useOpenAddBlockMenu } from '@wp-block-builder/stores/AddBlockMenuStore';
import { useEditableBlocksArrayField } from '@wp-block-builder/views/EditableMessage/hooks';

type Props = {
  blocksArrayName: string;
};
export default function AddContainerBlockPlaceholderButton({ blocksArrayName }: Props) {
  const fields = useEditableBlocksArrayField(blocksArrayName);
  const open = useOpenAddBlockMenu();
  const setCurrentBlockId = useSetCurrentBlockId();
  const onClick: MouseEventHandler<HTMLButtonElement> = useCallback(
    (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      open(ev.currentTarget, (block) => {
        fields.push(block);
        setCurrentBlockId(block.id);
      });
    },
    [fields, open, setCurrentBlockId]
  );

  return (
    <ButtonBase
      onClick={onClick}
      sx={{
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center',
        height: 48,
        width: '100%',
        bgcolor: 'rgba(0,0,0, 0.05)',
      }}
    >
      <AddOutlined
        sx={{
          p: 0.12,
          bgcolor: 'brand.blue',
          borderRadius: 24,
          color: 'primary.contrastText',
        }}
        fontSize="small"
      />
    </ButtonBase>
  );
}
